// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_3x7K-F9","rotate":"gXuxjtF","small":"_2CHy2D1","medium":"r61vilp","large":"_10ZqRoL"};